import { createSlice } from "@reduxjs/toolkit";

const initialState = JSON.parse(localStorage.getItem("localData")) || {
  mode: true,
  user: null,
  token: null,
  posts: [],
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === true ? false : true;
      localStorage.setItem('localData',JSON.stringify(state))
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem('localData',JSON.stringify(state))

    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.setItem('localData',JSON.stringify(state))

    },
    setFriends: (state, action) => {
      if (state.user) {
        state.user.friends = action.payload.friends;
        localStorage.setItem('localData',JSON.stringify(state))

      } else {
        console.error("user friends non-existent :(");
      }
    },
    setPosts: (state, action) => {
      state.posts = action.payload.posts;
      localStorage.setItem('localData',JSON.stringify(state))

    },
    setPost: (state, action) => {
      const updatedPosts = state.posts.map((post) => {
        if (post._id === action.payload.post._id) return action.payload.post;
        return post;
      });
      state.posts = updatedPosts;
      localStorage.setItem('localData',JSON.stringify(state))

    },
  },
});

export const { setMode, setLogin, setLogout, setFriends, setPosts, setPost } =
  appSlice.actions;
export default appSlice.reducer;